module.exports = __webpack_public_path__ + "img/neck.6a9693c9.svg";